exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-00a2f294]{margin-top:20px;text-align:center;font-size:30px;font-family:PingFang SC-Medium, PingFang SC;font-weight:500;color:rgba(0,0,0,0.85);margin-bottom:40px}.main[data-v-00a2f294]{max-width:800px;margin:0 auto}.main[data-v-00a2f294] p img{max-width:800px}.main[data-v-00a2f294] table{border:1px solid #ccc}.main[data-v-00a2f294] table th{border:1px solid #ccc}.main[data-v-00a2f294] table td{padding:10px 5px;border:1px solid #ccc}\n", ""]);

// exports
